module.exports = __webpack_public_path__ + "static/media/file.248c4289.svg";